import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';

import { AccountComponent } from './containers/account.component';
import { AccountInformationComponent } from './components/information/account-information.component';
import { AccountSubscriptionComponent } from './components/subscription/account-subscription.component';

import { AccountInvoicesService } from './services/account-invoices.service';
import { CompanySettingsService } from '../settings/services/company-settings.service';
import { AccountService } from './services/account.service';

import { DynamicTranslationModule } from '../shared/dynamic-translation/dynamic-translation.module';
import { IframeModule } from '../shared/iframe/iframe.module';
import { NavigationModule } from '../shared/navigation/navigation.module';
import { SharedModule } from '../shared/shared.module';

import { effects, reducers } from './store';

@NgModule({
  imports: [
    CommonModule,
    IframeModule,
    SharedModule,
    RouterModule,
    NavigationModule,
    DynamicTranslationModule,
    StoreModule.forFeature('accountInformation', reducers),
    EffectsModule.forFeature(effects)
  ],
  declarations: [
    AccountComponent,
    AccountSubscriptionComponent,
    AccountInformationComponent
  ],
  providers: [AccountService, AccountInvoicesService, CompanySettingsService]
})
export class AccountModule {}
